export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5461.ad46e185.jpg";